var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindingHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5161 6.81374C21.2058 6.09189 20.7584 5.43776 20.1988 4.88798C19.6389 4.33654 18.9787 3.89833 18.2542 3.59716C17.5029 3.2836 16.6971 3.12311 15.8835 3.12502C14.7422 3.12502 13.6286 3.439 12.6609 4.03208C12.4294 4.17395 12.2095 4.32978 12.0011 4.49957C11.7928 4.32978 11.5729 4.17395 11.3413 4.03208C10.3736 3.439 9.26009 3.12502 8.11876 3.12502C7.2969 3.12502 6.50052 3.28317 5.74811 3.59716C5.02118 3.89951 4.36601 4.33444 3.80345 4.88798C3.24317 5.43714 2.79562 6.09142 2.48617 6.81374C2.16437 7.56498 2 8.36273 2 9.18374C2 9.95823 2.15743 10.7653 2.46996 11.5863C2.73157 12.2724 3.10661 12.9841 3.58583 13.7028C4.34518 14.8401 5.38928 16.0263 6.68572 17.2287C8.83412 19.2219 10.9617 20.5988 11.052 20.6546L11.6006 21.0081C11.8437 21.164 12.1563 21.164 12.3993 21.0081L12.948 20.6546C13.0383 20.5965 15.1635 19.2219 17.3143 17.2287C18.6107 16.0263 19.6548 14.8401 20.4141 13.7028C20.8934 12.9841 21.2707 12.2724 21.53 11.5863C21.8425 10.7653 22 9.95823 22 9.18374C22.0023 8.36273 21.8379 7.56498 21.5161 6.81374Z",
    fill: "#EB7452"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindingHeart);
export default __webpack_public_path__ + "static/media/finding-heart.38be3dbc54953c2f3c196d97e17ebecb.svg";
export { ForwardRef as ReactComponent };